import React, { useState } from "react";
import { useSaveInventoryMutation, useGetInventoriesQuery } from "../api/starterKitApi";
import { showToast } from "../../../core/utils/alert";
import { getApiErrorMessage } from "../../../core/utils/errorHandler";
import CommonSelect from "../../../core/common/commonSelect";
import { useCourse } from "../../configuration/course/hooks/useCourse";

const AddInventoryModal = () => {
  const [formData, setFormData] = useState({
    course_id: "",
    total_stock: 0,
    available_stock: 0,
    is_main_center_stock: true,
  });

  const { data: allMainCenterData } = useGetInventoriesQuery({ is_main_center_stock: 1 });
  const mainCenterStocks = allMainCenterData?.data?.items || [];

  const { getCourseState } = useCourse();
  const { courses } = getCourseState();
  
  const availableCourses = courses.filter((c: any) => 
    !mainCenterStocks.some((s: any) => Number(s.course_id) === Number(c.id) || Number(s.course?.id) === Number(c.id))
  );

  const courseOptions = availableCourses.map((course: any) => ({
    value: course.id.toString(),
    label: course.name,
  }));

  const [saveInventory, { isLoading }] = useSaveInventoryMutation();


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await saveInventory({
        ...formData,
        course_id: Number(formData.course_id)
      }).unwrap();
      if (response.success) {
        showToast({
          title: "Success",
          text: "Stock initialized successfully",
          icon: "success",
        });
        // Close modal using bootstrap
        const modalElement = document.getElementById("add_inventory");
        if (modalElement) {
          const bootstrap = (window as any).bootstrap;
          if (bootstrap && bootstrap.Modal) {
            const modal = bootstrap.Modal.getInstance(modalElement);
            modal?.hide();
          } else {
            // Fallback: search for a close button and click it
            const closeButton = modalElement.querySelector('[data-bs-dismiss="modal"]') as HTMLButtonElement;
            closeButton?.click();
          }
        }
      }
    } catch (error: any) {
      console.error("Add inventory error:", error);
      showToast({
        title: "Error",
        text: getApiErrorMessage(error) || "Failed to add stock",
        icon: "error",
      });
    }
  };

  return (
    <div className="modal fade" id="add_inventory">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Add Initial Stock</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <label className="form-label">Course</label>
                    <CommonSelect
                      options={courseOptions}
                      value={courseOptions.find(opt => opt.value === formData.course_id)}
                      onValueChange={(val) => setFormData({ ...formData, course_id: val })}
                      placeholder="Select Course"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Total Stock Quantity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.total_stock}
                      onChange={(e) => setFormData({
                        ...formData,
                        total_stock: Number(e.target.value),
                        available_stock: Number(e.target.value) // Sync available with total for initial entry
                      })}
                      required
                      min="1"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={isLoading}>
                {isLoading ? "Saving..." : "Save Stock"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddInventoryModal;
